import { render } from "./AppFormSwitch.vue?vue&type=template&id=5ab19d2c&scoped=true"
import script from "./AppFormSwitch.vue?vue&type=script&lang=js"
export * from "./AppFormSwitch.vue?vue&type=script&lang=js"

import "./AppFormSwitch.vue?vue&type=style&index=0&id=5ab19d2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ab19d2c"]])

export default __exports__